import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import useCheckoutSession from '../../../hooks/useCheckoutSession';
import PriceOffer from './PriceOffer';

// Road-record and integrity-certificate orders use the legacy checkout
// session, but must continue on their own service route.
export default function ServiceOrderOffer({servicePath}) {
    const session = useCheckoutSession('legacy');
    const navigate = useNavigate();

    const back = () => {
        session.resetSession();
        navigate(servicePath);
    };

    const continueToDocuments = () => {
        session.updateOrderState('DOCUMENTS');
        navigate(`${servicePath}/complete-offer`);
    };

    return <>
        <PriceOffer/>
        <Typography variant="h6" sx={{mb: 2}}>
            Încarcă documentele necesare pentru a continua
        </Typography>
        <Stack direction={{xs: 'column', sm: 'row'}} spacing={2}>
            <Button fullWidth size="large" variant="contained" color="warning" onClick={back}>
                Înapoi
            </Button>
            <Button fullWidth size="large" variant="contained" onClick={continueToDocuments}>
                Încărcare documente
            </Button>
        </Stack>
    </>;
}
